module.exports = __webpack_public_path__ + "img/lovemessage@2x.deb2317a.png";